module.exports = __webpack_public_path__ + "static/media/SO.4fb0334d.svg";